module.exports = __webpack_public_path__ + "assets/img/bluetulip.028c2008.jpg";